import { FC } from 'react';
import { DatePicker } from 'antd';
import type { DatePickerProps } from 'antd';
import { DATE_FORMAT } from '../../../assets/conts';

const SDatePicker: FC<DatePickerProps> = (props) => {
  return (
    <DatePicker
      id={props.id}
      name={props.name}
      format={DATE_FORMAT}
      value={props.value}
      disabled={props.disabled}
      placeholder={props.placeholder}
      onChange={props.onChange}
    />
  );
};

export default SDatePicker;
